import React, {useCallback, useEffect, useState} from 'react';
import {ScraperStatusPayload} from "../../../types/Scraper";
import {useIsSuperuser} from "../../../utils/UserSession";
import {useNavigate} from "react-router";
import {useAlerts} from "../../../utils/UserAlerts";
import {useRestClient} from "../../../client/SpmRestClient";
import {StringUtil} from "zavadil-ts-common";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Button, Card, Form, Stack} from "react-bootstrap";
import SelectContactSource from "../../../components/SelectContactSource";
import {GenericResponsePayload} from "../../../types/GenericResponsePayload";

export default function ScraperPage() {
	const navigate = useNavigate();
	const userAlerts = useAlerts();
	const restClient = useRestClient();
	const [sourceId, setSourceId] = useState<string | null | undefined>();
	const [scraperStatus, setScraperStatus] = useState<ScraperStatusPayload>();
	const isSuperUser = useIsSuperuser();

	const loadStatus = useCallback(
		() => {
			restClient.scraper
				.status()
				.then(setScraperStatus)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts]
	);

	const commandExecuted = useCallback(
		(response: GenericResponsePayload) => {
			loadStatus();
			response.success
				? userAlerts.info(StringUtil.toString(response.message))
				: userAlerts.err(StringUtil.toString(response.error));
		},
		[userAlerts, loadStatus]
	)
	const scrapeAll = useCallback(
		() => {
			restClient.scraper
				.scrapeAll()
				.then(commandExecuted)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, commandExecuted, userAlerts]
	);

	const scrapeLookups = useCallback(
		() => {
			restClient.scraper
				.scrapeLookups()
				.then(commandExecuted)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts, commandExecuted]
	);

	const scrapeContacts = useCallback(
		() => {
			restClient.scraper
				.scrapeContacts(sourceId || undefined)
				.then(commandExecuted)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts, sourceId, commandExecuted]
	);

	const stopScraper = useCallback(
		() => {
			restClient.scraper
				.stop()
				.then(commandExecuted)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts, commandExecuted]
	);

	useEffect(
		() => {
			const timerID = setInterval(loadStatus, 3000);
			return function cleanup() {
				clearInterval(timerID);
			};
		},
		[loadStatus]
	);

	useEffect(loadStatus, []);

	if (!isSuperUser) {
		userAlerts.err('Nemáte oprávnění k přístupu na tuto stránku');
		navigate('/admin');
		return <></>;
	}

	return <div>
		<h1>Scraper</h1>
		<Row>
			<Col md={3}>
				<Stack gap={2}>
					<Button onClick={scrapeAll}>Vše</Button>
					<Button onClick={scrapeLookups}>Pomocné tabulky</Button>
					<Card>
						<Card.Header>
							<Form.Label>Zdroj dat</Form.Label>
						</Card.Header>
						<Card.Body>
							<Stack gap={2}>
								<SelectContactSource
									sourceId={sourceId}
									onChange={setSourceId}
								/>
								<Button onClick={scrapeContacts} disabled={StringUtil.isBlank(sourceId)}>Kontakty z jednoho zdroje</Button>
							</Stack>
						</Card.Body>
					</Card>
					<Button
						variant="danger"
						onClick={stopScraper}
					>Stop</Button>
				</Stack>
			</Col>
			<Col>
				<Card>
					<Card.Header>Status</Card.Header>
					<Card.Body>
						<strong>Active job:</strong>{' '}
						{scraperStatus ? scraperStatus.activeJobName : 'loading...'}
						<br/>
						<strong>Active job state:</strong>{' '}
						{scraperStatus ? scraperStatus.activeJobStatus : 'loading...'}
						<br/>
						<strong>Queue:</strong>
						<br/>
						{scraperStatus ? (
							<ul>
								{scraperStatus.queue.map(job => (
									<li>{job}</li>
								))}
							</ul>
						) : (
							'nahrávám...'
						)}
					</Card.Body>
				</Card>
			</Col>
		</Row>
	</div>
}
